import { useQuery } from "@tanstack/react-query";
import { GitBranch, ArrowRight } from "lucide-react";
import api from "@/lib/api";

const DOT = { Approved: "bg-emerald-500", Obsolete: "bg-slate-400", Draft: "bg-slate-300", "Under Review": "bg-amber-400", Rejected: "bg-rose-500" };
const dt = (v) => v ? String(v).slice(0, 10) : null;

export const DocChain = ({ row, onOpen }) => {
  const q = useQuery({ queryKey: ["qms", "doc-chain", row.id], queryFn: async () => (await api.get(`/qms/documents/${row.id}/chain`)).data });
  const items = q.data?.items || [];
  if (q.isLoading) return <div className="h-8 animate-pulse rounded bg-slate-100" />;
  if (items.length < 2) return null;
  return (
    <div className="rounded-md border border-slate-200 p-3 text-xs" data-testid="qms-doc-chain">
      <div className="pp-label flex items-center gap-1 mb-2"><GitBranch size={12} /> Revision & replacement timeline · {q.data.refs.length > 1 ? `${q.data.refs.join(" → ")}` : row.ref_no}</div>
      <ol className="relative border-l border-slate-200 ml-2 space-y-2">
        {items.map((it) => <li key={it.id} className="ml-4" data-testid={`qms-chain-${it.id}`}>
          <span className={`absolute -left-[5px] mt-1 h-2.5 w-2.5 rounded-full ${DOT[it.status] || "bg-slate-300"}`} />
          <div className={`flex flex-wrap items-center gap-x-2 ${it.current ? "font-semibold" : ""}`}>
            <button className={`font-mono ${it.current ? "text-slate-900" : "text-blue-700 underline"}`} disabled={it.current} onClick={() => onOpen(it)} data-testid={`qms-chain-open-${it.id}`}>{it.ref_no} rev {it.revision ?? "—"}</button>
            <span className={`rounded px-1.5 py-0.5 text-[10px] ${it.status === "Approved" ? "bg-emerald-100 text-emerald-800" : it.status === "Obsolete" ? "bg-slate-200 text-slate-600 line-through" : "bg-slate-100 text-slate-700"}`}>{it.status}</span>
            {it.current && <span className="text-[10px] text-blue-700">(this record)</span>}
            <span className="text-slate-500 truncate">{it.title}</span>
          </div>
          <div className="text-slate-500">
            created {dt(it.created_at)}{it.approved_at ? ` · approved ${dt(it.approved_at)} by ${it.approved_by || "—"}` : ""}{it.obsoleted_at ? ` · obsolete ${dt(it.obsoleted_at)} by ${it.obsoleted_by || "—"}` : ""}
            {it.change_summary ? <span> · change: {it.change_summary}</span> : null}
            {it.obsolete_reason ? <span> · reason: {it.obsolete_reason}</span> : null}
            {it.replaced_by ? <span className="inline-flex items-center gap-0.5 text-slate-700"> · replaced by <ArrowRight size={10} /> <b>{it.replaced_by}</b></span> : null}
          </div>
        </li>)}
      </ol>
    </div>
  );
};
